import { render, staticRenderFns } from "./TimeAllocationForm.vue?vue&type=template&id=32b7a823&scoped=true"
import script from "./TimeAllocationForm.vue?vue&type=script&lang=js"
export * from "./TimeAllocationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b7a823",
  null
  
)

export default component.exports